/**
 * File: purchaseOrder.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class PurchaseOrderController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        let academicYear = localStorageService.get('academic_year')
        $scope.newDate = new Date();
        $scope.productList = [{
            company_name: null,
            medicine_name: null,
            medicine_type: null,
            vials_count: null,
            div_color: false
        }]
        $scope.addProductFromToList = () => {
            let len = $scope.productList.length
            if (len % 2 === 0) {
                $scope.productList.push({
                    "div_color": false
                })
            } else {
                $scope.productList.push({
                    "div_color": true
                })
            }
        }
        $scope.submitOrder = () => {

            let productObj = []
            let errorCount = 0
            _.each($scope.productList, function(each) {
                each.errors = {}
                let eachObj = {
                    company_name: each.company_name ? each.company_name : null,
                    medicine_name: each.medicine_name ? each.medicine_name : null,
                    medicine_type: each.medicine_type ? each.medicine_type : null,
                    vials_count: each.vials_count ? each.vials_count : null,
                    school_id: schoolId,
                    user_id: userId,
                    academic_year: academicYear
                }
                if (errorCount === 0)
                    productObj.push(eachObj)
            })
            if (productObj.length === $scope.productList.length) {
                authService.callAPI(MEDICALCONSTANT.API_SAVE_PURCHASE_ORDER, "POST", productObj, (response) => {
                    if (response.result && response.result.data && response.result.data.data) {
                        toastr.success("Purchase Order saved Successfully")
                        $state.go('purchaseList')
                    }
                })
            }

        }
        $scope.removeProduct = (product, index) => {
            if ($scope.productList.length > 1) {
                $scope.productList.splice(index, 1);
            }
        }
    }
}
export default PurchaseOrderController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/inventory/purchaseOrder.js